import * as C from '../common/constants';
import * as THREE from 'three';
import Model from './Model';
import { Canvas, useLoader, useFrame } from '@react-three/fiber';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useEffect, useRef, Suspense, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { useColor } from '../common/hooks/useColor';
import { useBlades } from '../common/hooks/useBlades';
import { useLights } from '../common/hooks/useLights';
import Bloom from './Bloom';
import Background from './Background';
import Orbit from './Orbit';
import clsx from 'clsx';
import {
  Stats,
  OrbitControls,
  Circle,
  useProgress,
  Decal,
  useTexture,
  useGLTF,
  Environment,
} from '@react-three/drei';

const GLB_URL = './assets/t03042024.glb';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      sceneStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        transition: '0.5s ease',
      },
      menuOpenStyle: {
        paddingLeft: '150px',
      },
    })
);

useGLTF.preload(GLB_URL);

const Scene = () => {
  const dispatch: any = useDispatch();
  const classes = useStyles();
  const ref = useRef(null);

  const menuSide = useSelector((state: any) => state.app[C.SET_MENU]);
  const isMenuVisible = Boolean(menuSide);

  const isSkyVisible = useSelector((state: any) => state.app[C.SET_SKY]);

  // necessary for Bloom
  // const ambientLightRef = useRef(null);
  const bulbGreenRef = useRef(null);
  const bulbRedRef = useRef(null);

  const data = useGLTF(GLB_URL) as any;
  const { nodes, scene, materials, animations } = data;

  useColor(materials);
  useBlades(materials);
  useLights(materials);

  if (!ref?.current && scene) {
    ref.current = scene;
  }

  console.log('>>>>RENDER');

  const onCreated = ({ camera, scene }) => {
    // necessary for grey background
    const light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.set(0, 1, 1).normalize();
    light.intensity = 5;
    // light.castShadow = true;
    camera.add(light);

    // const spotLight = new THREE.SpotLight(0xffffff, 2);
    // // spotLight.position.set(45, 50, 15);
    // spotLight.position.set(0, 1, 1).normalize();
    // camera.add(spotLight);

    // const ambLight = new THREE.AmbientLight(0x333333, 2);
    // // ambLight.position.set(5, 3, 5);
    // ambLight.position.set(0, 1, 1).normalize();
    // camera.add(ambLight);

    // const pointLight = new THREE.PointLight(0xffffff, 2, 100);
    // pointLight.position.set(10, 10, 10);
    // camera.add(pointLight);

    scene.add(camera);
  };

  return (
    <div
      className={clsx(
        classes.sceneStyle,
        isMenuVisible && classes.menuOpenStyle
      )}
    >
      {/* <Suspense fallback={<div>{'Loading...'}</div>}> */}
      <Canvas
        camera={{ fov: 65, position: [0, 0, 7] }}
        shadows
        gl={{
          antialias: true,
          alpha: false,
          powerPreference: 'high-performance',
          preserveDrawingBuffer: true,
        }}
        onCreated={onCreated}
        // frameloop="demand"
      >
        {!isSkyVisible && (
          <>
            <pointLight
              position={[2, 2, 0]}
              color={0xffffff}
              intensity={20}
              distance={100}
              castShadow
              // receiveShadow
              shadow-bias={-0.0005}
              power={1000}
            />

            <spotLight
              intensity={100}
              angle={Math.PI / 4}
              penumbra={1}
              decay={2}
              position={[5, -1, -3]}
              rotation={[-0.5, 0.5, 0]}
              shadow-bias={-0.0005}
              // power={1000}
              castShadow
            />
          </>
        )}

        <Bloom bulbRedRef={bulbRedRef} bulbGreenRef={bulbGreenRef} />

        {/* <directionalLight
          position={[0, 1, 1]}
          intensity={10}
          color={0xffffff}
          // castShadow
          // shadow-mapSize-width={2048}
          // shadow-mapSize-height={2048}
        /> */}

        <Model
          data={data}
          bulbRedRef={bulbRedRef}
          bulbGreenRef={bulbGreenRef}
        />

        <Background />

        <Orbit />

        {/* <axesHelper args={[5]} /> */}
        {/* <Stats /> */}
      </Canvas>
      {/* </Suspense> */}
    </div>
  );
};

export default Scene;
